<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :form="form"
    :actionButtons="['show']"
    :title="$t('menu.userVerifications')"
    :actions="$route.params.id ? actions : []"
    resource="user_verifications"
    :onFetchData="onFetchData"
    :onFormSubmit="onFormSubmit"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/users.js';
import { formColumnsExtend as profileFormColumnsExtend, columnsExtend as profileColumnsExtend } from '../admin_entities/profile_detail.js';
import { formColumnsExtend as walletHolderFormColumnsExtend, columnsExtend as walletHolderColumnsExtend } from '../admin_entities/miapay/wallet_holder_detail.js';
import { TEST_ACCOUNT_FOR_APPLE, TAG_TYPE } from '@/constants';

@Component
export default class UserVerifications extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
      'miapay_wallet_holder_phone_cont',
      'verification_state_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const [avatar, first_name, last_name, whatsapp] = profileColumnsExtend(['avatar', 'first_name', 'last_name', 'whatsapp'], { data: {}, type: type })
    const [certificate_front, certificate_back, card_ownership, passport, id_type, verify_type, certificate_expired_date] = walletHolderColumnsExtend(['certificate_front', 'certificate_back', 'card_ownership', 'passport', 'id_type', 'verify_type', 'certificate_expired_date'], { data: {}, type: type })
    const array = [
      type === 'show' && 'id',
      type === 'show' && {
        ...avatar,
        prop: 'miapay_wallet_holder_attributes.profile_attributes.avatar'
      },
      type === 'show' && 'is_block',
      {
        key: 'phone',
        renderCell: (h, { props: { value } }) => {
          return <span>{ TEST_ACCOUNT_FOR_APPLE.includes(value) ? `${value} (Not real, test account for apple)` : value }</span>;
        }
      },
      type === 'show' && 'number',
      'verification_state',
      {
        prop: 'verifier',
        label: this.$t('user.agentVerifier'),
        renderCell: (h, { props: { value } }) => {
          if (value && value.cn === 'Agent') {
            return <bean-link to={{ name: 'agents.show', params: { id: value.id } }}>{ value.name || value.phone }</bean-link>
          } else {
            return <span>/</span>
          }
        }
      },
      type === 'show' && {
        ...id_type,
        prop: 'miapay_wallet_holder_attributes.id_type',
        width: 180,
        renderCell: (h, { props: { value } }) => {
          return <el-tag>{ this.$t(`miapay/walletHolder.idTypes.${value}`) }</el-tag>;
        }
      },
      {
        ...verify_type,
        prop: 'miapay_wallet_holder_attributes.verify_type',
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <el-tag type={TAG_TYPE[value]}>{ this.$t(`miapay/walletHolder.verifyTypes.${value}`) }</el-tag>;
          }
        }
      },
      type === 'show' && 'verify_at',
      type === 'show' && {
        ...first_name,
        prop: 'miapay_wallet_holder_attributes.profile_attributes.first_name'
      },
      type === 'show' && {
        ...last_name,
        prop: 'miapay_wallet_holder_attributes.profile_attributes.last_name'
      },
      type === 'show' && {
        ...whatsapp,
        prop: 'miapay_wallet_holder_attributes.profile_attributes.whatsapp'
      },
      type === 'show' && {
        ...certificate_front,
        prop: 'miapay_wallet_holder_attributes.certificate_front'
      },
      type === 'show' && {
        ...certificate_back,
        prop: 'miapay_wallet_holder_attributes.certificate_back'
      },
      type === 'show' && {
        ...card_ownership,
        prop: 'miapay_wallet_holder_attributes.card_ownership'
      },
      type === 'show' && {
        ...passport,
        prop: 'miapay_wallet_holder_attributes.passport'
      },
      type === 'show' && {
        ...certificate_expired_date,
        prop: 'miapay_wallet_holder_attributes.certificate_expired_date'
      },
      type === 'show' && { key: 'reject_reason' },
      type === 'show' && 'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const [first_name, last_name, whatsapp] = profileFormColumnsExtend(['first_name', 'last_name', 'whatsapp'], { data, type: type })
    const [number] = walletHolderFormColumnsExtend(['number'], { data, type: type });
    const array = [
      {
        ...number,
        prop: 'miapay_wallet_holder_attributes.number'
      },
      {
        ...first_name,
        prop: 'miapay_wallet_holder_attributes.profile_attributes.first_name'
      },
      {
        ...last_name,
        prop: 'miapay_wallet_holder_attributes.profile_attributes.last_name',
      },
      {
        ...whatsapp,
        prop: 'miapay_wallet_holder_attributes.profile_attributes.whatsapp'
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */

  actions({ row }, { reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'user_verifications.edit', params: { id: row.id } },
          can: 'users.update'
        }
      },
      ['pending', 'rejected'].includes(row.verification_state) && {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.user.approve'),
          can: 'users.review',
          type: 'success'
        },
        on: {
          confirm: async () =>  {
            await this.$autoLoading(this.$request.put(`/users/${row.id}/approve`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.verification_state === 'pending' && {
        component: 'dialogFormButton',
        props: {
          label: this.$t('actions.user.reject'),
          can: 'users.review',
          value: row,
          columns: formColumnsExtend([
            {
              key: 'reject_reason',
              renderCell: {
                required: true,
              }
            }
          ], { data: row }),
          submitHandler: async (value) => {
            await this.$autoLoading(this.$request.put(`/users/${row.id}/reject`, value));
            this.$message.success(this.$t('operateSuccess'));
            reload(row.id);
          }
        }
      },
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/users', { params: { ...this.$route.query, verification_state_in: ['pending', 'approved', 'rejected'], order_by: 'info_filled_in_at DESC' } });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/users/${this.$route.params.id}`);
      return { data };
    }
  }

  async onFormSubmit({ data }) {
    const body = data;

    const id = this.$route.params.id
    await this.$request.put(`users/${id}`, body);
    this.$message.success(this.$t('bean.updateSuccess'));
    this.$router.push({ name: 'user_verifications.show', params: { id: id } });
  }
}

export const route = [
  {
    path: '/user_verifications',
    name: 'user_verifications.index',
    component: UserVerifications,
    props: {
      type: 'index',
    },
    meta: {
      can: 'users.read'
    }
  },
  {
    path: '/user_verifications/:id',
    name: 'user_verifications.show',
    component: UserVerifications,
    props: {
      type: 'show',
    },
    meta: {
      can: 'users.read'
    }
  },
  {
    path: '/user_verifications/:id/edit',
    name: 'user_verifications.edit',
    component: UserVerifications,
    props: {
      type: 'edit'
    },
    meta: {
      can: 'users.update'
    }
  }
]
</script>
